// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { FolderThirdPartiesInstance } from "./helpers/folderThirdPartiesInstanceHelpers";
import { createFolderThirdPartiesInstance } from "./helpers/folderThirdPartiesInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, FolderThirdPartiesInstance>({
	name: "FolderThirdParties",
	createBase: createBaseNotary,
	createInstance: createFolderThirdPartiesInstance,
});

export function getFolderThirdPartiesInstance(): FolderThirdPartiesInstance {
	return factory.getInstance();
}
